export default "__VITE_ASSET__262217f7__"